import calculRepartitionTva from '@/services/devisCommandes/calcul/calculRepartitionTva';
import calculLigneNormalDevis from '@/services/devisCommandes/calcul/calculLigneCommandeNormal';
import calculLigneCommandeRegroupement from '@/services/devisCommandes/calcul/calculLigneCommandeRegroupement';
import calculArrondi from '@/services/calcul/calculArrondi';
import * as devisConf from '@/configuration/devisConf';
import { SANS_SUITE, INDISPONIBLE, ANNULATION } from '@/configuration/optionBlocage/optionBlocage';
import isLigneRegroupement from '@/services/devisCommandes/isLigneRegroupement';
import findAndCalculHonoraire from '@/services/devisCommandes/calcul/findAndCalculHonoraire';

export default function calculCommandeDevis(devisCommande) {
  if (!devisCommande) return;
  devisCommande.montantHt = 0;
  let listeLigneCommande = null;
  const etatsExclus = [SANS_SUITE, INDISPONIBLE, ANNULATION];
  // lignes enfants d'un regroupement inactif (panneau supprimé de la recommandation)
  const lignesEnfantsExclues = new Set();
  if (devisCommande.lignesCommande) {
    listeLigneCommande = devisCommande.lignesCommande;
    listeLigneCommande.forEach((ligne) => {
      if (ligne.type === devisConf.REGROUPEMENT && ligne.lignesCommande) {
        listeLigneCommande = listeLigneCommande.concat(ligne.lignesCommande);
        if (etatsExclus.includes(ligne.etatObtenu)) {
          ligne.lignesCommande.forEach(enfant => lignesEnfantsExclues.add(enfant));
        }
      }
    });
    listeLigneCommande.sort((a, b) => a.ordre - b.ordre);
    listeLigneCommande
      .filter((ligne) => ligne.type === devisConf.NORMAL)
      .forEach((ligne) => {
        calculLigneNormalDevis(ligne);
        ligne.totalHtAvecLigneRemise = ligne.totalHt;
      });

    findAndCalculHonoraire(listeLigneCommande);

    listeLigneCommande.forEach((ligne) => {
      if (ligne.type === devisConf.REGROUPEMENT && ligne.lignesCommande) {
        calculLigneCommandeRegroupement(ligne);
      }
    });


    listeLigneCommande
      .filter((ligne) => [devisConf.NORMAL, devisConf.REMISE].includes(ligne.type))
      .forEach((ligne) => {
        if (devisCommande.type === devisConf.TYPE_DEVIS
          && (lignesEnfantsExclues.has(ligne)
            || (etatsExclus.includes(ligne.etatObtenu)
              && isLigneRegroupement(devisCommande, ligne.referenceRegroupement)))) return;
        devisCommande.montantHt = calculArrondi(ligne.totalHt + devisCommande.montantHt);
      });
  }
  calculRepartitionTva(devisCommande, listeLigneCommande, lignesEnfantsExclues);
}
